import React from 'react';
import { View } from 'react-native';

import { valueExists } from '../../../common/utils/utils';

import { Button } from '../../components';
import Text from '../../components/text/Text';
import { DateSelectorInput } from '../../components/input';
import StocktakeQuantitySelector from '../../components/stocktake/StocktakeQuantitySelector';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const PendingStockBatchRows = ({
	rows,
	warehouseProduct,
	updateRow,
	addRow,
	removeRow,
	totalText,
	disabled,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<>
			<Text style={styles.inputLabel}>Batches</Text>
			{(rows || []).map((row, index) => (
				<View key={index} style={styles.batchRow}>
					<Text style={styles.batchHeading}>Batch {index + 1}</Text>
					<StocktakeQuantitySelector
						warehouseProduct={warehouseProduct}
						value={valueExists(row.quantity) ? row.quantity : null}
						onChange={value => updateRow(index, 'quantity', value)}
						disabled={disabled}
					/>
					<DateSelectorInput
						value={row.expiryDate || ''}
						onChange={value => updateRow(index, 'expiryDate', value)}
						placeholder="Expiry date"
						disabled={disabled}
						style={styles.batchInput}
					/>
					{rows.length > 1 && (
						<Button
							label="Remove batch"
							onPress={() => removeRow(index)}
							disabled={disabled}
						/>
					)}
				</View>
			))}
			<View style={styles.batchFooter}>
				<Button
					label="Add batch"
					onPress={addRow}
					disabled={disabled}
				/>
				<Text style={styles.batchTotalText}>{totalText}</Text>
			</View>
		</>
	);
};

const createStyles = ({ ui: { colors, type, space, radius } }) => ({
	inputLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: space.xs,
		marginTop: space.sm,
	},
	batchRow: {
		borderWidth: 1,
		borderColor: colors.border,
		borderRadius: radius.card,
		backgroundColor: colors.card,
		padding: space.md,
		marginTop: space.sm,
		gap: space.sm,
	},
	batchHeading: {
		...type.overline,
		color: colors.textSecondary,
	},
	batchInput: {
		marginTop: space.xs,
	},
	batchFooter: {
		marginTop: space.md,
		gap: space.sm,
	},
	batchTotalText: {
		...type.secondary,
		color: colors.textSecondary,
	},
});

export default PendingStockBatchRows;
